"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _hooks = require("../../../hooks");

var _components = require("../../../components");

var _LocationCardModule = _interopRequireDefault(require("./LocationCard.module.scss"));

var _Hours = _interopRequireDefault(require("../Hours"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var LocationCardType2 = function LocationCardType2(_ref) {
  var address = _ref.address,
      cellType = _ref.cellType,
      dataTest = _ref.dataTest,
      diningOption = _ref.diningOption,
      estimateText = _ref.estimateText,
      formattedDistance = _ref.formattedDistance,
      formattedPhone = _ref.formattedPhone,
      idx = _ref.idx,
      innerRef = _ref.innerRef,
      isOpen = _ref.isOpen,
      name = _ref.name,
      onEnterMenu = _ref.onEnterMenu,
      orderButtonCopy = _ref.orderButtonCopy,
      orderTypeHours = _ref.orderTypeHours;

  var _useTemplate$useCell = _hooks.useTemplate.useCell(cellType),
      buttons = _useTemplate$useCell.buttons,
      views = _useTemplate$useCell.views,
      labelTextStyles = _useTemplate$useCell.labelTextStyles;

  var hoursProps = function hoursProps(orderType) {
    return _objectSpread({
      primaryType: labelTextStyles.quaternary,
      secondaryType: labelTextStyles.quinary
    }, orderTypeHours(orderType));
  };

  return /*#__PURE__*/_react["default"].createElement(_components.View, {
    Component: "li",
    type: views.background,
    direction: "column",
    innerRef: innerRef,
    dataTest: dataTest,
    className: [_LocationCardModule["default"].container, "location-card"]
  }, /*#__PURE__*/_react["default"].createElement(_components.View, {
    className: _LocationCardModule["default"].card,
    type: views.secondary,
    direction: "row",
    padding: 15,
    justify: "between",
    align: "center"
  }, /*#__PURE__*/_react["default"].createElement(_components.Box, {
    grid: {
      xs: "2-3"
    }
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    role: "heading",
    "aria-level": "3",
    "aria-label": name,
    type: labelTextStyles.primary
  }, name)), /*#__PURE__*/_react["default"].createElement(_components.Box, {
    grid: {
      xs: "1-3"
    },
    justify: "end"
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.secondary,
    className: _LocationCardModule["default"].distance
  }, formattedDistance))), /*#__PURE__*/_react["default"].createElement(_components.Box, {
    className: _LocationCardModule["default"].address,
    direction: "row",
    justify: "between",
    padding: 15
  }, /*#__PURE__*/_react["default"].createElement(_components.Box, {
    justify: "between",
    direction: "column",
    className: "type2-location-card-body-address"
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.tertiary
  }, formattedPhone), /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.tertiary
  }, address[0]), /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.tertiary
  }, address[1]), /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.tertiary
  }, estimateText)), /*#__PURE__*/_react["default"].createElement(_components.Box, {
    justify: "start",
    direction: "column"
  }, /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
    type: buttons.primary,
    onClick: onEnterMenu,
    size: "md",
    disabled: !isOpen,
    className: _LocationCardModule["default"]["order-button"],
    dataTest: "location-card-order-button-".concat(idx + 1)
  }, orderButtonCopy))), /*#__PURE__*/_react["default"].createElement(_components.Box, {
    className: _LocationCardModule["default"].card,
    direction: "column",
    justify: "between",
    padding: 15
  }, /*#__PURE__*/_react["default"].createElement(_components.Box, {
    direction: "column",
    style: {
      marginBottom: "0.75rem"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Hours["default"], hoursProps(diningOption))), diningOption !== "kiosk" && /*#__PURE__*/_react["default"].createElement(_components.Box, {
    direction: "column"
  }, /*#__PURE__*/_react["default"].createElement(_Hours["default"], hoursProps("kiosk")))));
};

var _default = /*#__PURE__*/_react["default"].memo(LocationCardType2);

exports["default"] = _default;